// extracted by mini-css-extract-plugin
module.exports = {"inline-code":"inline-code--503d64","inlineCode":"inline-code--503d64","inline-code_tiny":"inline-code_tiny--577f81","inlineCode_tiny":"inline-code_tiny--577f81"};